// src/ui.js

export function setupUI(k, state) {
    const {
        HUD_MARGIN,
        HUD_HEIGHT,
        HP_BAR_WIDTH,
        HP_BAR_HEIGHT,
        COOLDOWN_BAR_WIDTH,
        BACKDROP_WIDTH,
        BACKDROP_HEIGHT,
        ARENA_PADDING
    } = state.constants;

    const ui = {};
    const FONT_SETTINGS = { size: 22, font: "font_arcade" };

    // --- Background and Arena ---
    ui.background = k.add([k.sprite("background-space"), k.pos(k.width()/2, k.height()/2), k.anchor("center"), k.fixed(), k.z(-120)]);
    ui.vignette = k.add([k.sprite("vignette"), k.pos(k.width()/2, k.height()/2), k.anchor("center"), k.fixed(), k.z(60), k.opacity(0.55)]);
    ui.arenaFloor = k.add([k.rect(1,1), k.color(30,20,70), k.opacity(0.35), k.z(-50)]);
    ui.arenaGlow = k.add([k.rect(1,1), k.color(80,120,255), k.opacity(0.25), k.z(-40)]);
    
    // --- HUD Base ---
    ui.hudGlowBack = k.add([k.rect(1,1, {radius: 28}), k.color(35,15,70), k.opacity(0.35), k.fixed(), k.z(79)]);
    ui.hudPanel = k.add([k.rect(1,1, {radius: 24}), k.color(16,10,42), k.opacity(0.92), k.outline(3, k.rgb(84, 88, 190)), k.fixed(), k.z(80)]);
    ui.hudTopLine = k.add([k.rect(1,1, {radius: 3}), k.color(130,100,255), k.opacity(0.4), k.fixed(), k.z(84)]);
    ui.hudAccent = k.add([k.rect(1,1, {radius: 2}), k.color(255,140,120), k.opacity(0.55), k.fixed(), k.z(85)]);
    ui.hudDivider = k.add([k.rect(2,1, {radius: 1}), k.color(70,62,130), k.opacity(0.35), k.fixed(), k.z(88)]);
    ui.playerPortrait = k.add([k.sprite("player-portrait"), k.scale(1.2), k.fixed(), k.z(90)]);
    ui.enemyPortrait = k.add([k.sprite("enemy-portrait"), k.scale(1.2), k.fixed(), k.z(90)]);
    
    // --- Labels & Bars ---
    ui.playerHpLabel = k.add([k.text("", {...FONT_SETTINGS, size: 20}), k.color(190,225,255), k.fixed(), k.z(90)]);
    ui.enemyHpLabel = k.add([k.text("", {...FONT_SETTINGS, size: 20}), k.color(255,170,180), k.fixed(), k.z(90)]);
    ui.waveLabel = k.add([k.text("", FONT_SETTINGS), k.color(198,225,255), k.fixed(), k.z(90)]);
    ui.scoreLabel = k.add([k.text("", FONT_SETTINGS), k.color(182,255,212), k.fixed(), k.z(90)]);
    ui.enemyCountLabel = k.add([k.text("", FONT_SETTINGS), k.color(210,200,255), k.fixed(), k.z(90)]);
    ui.comboLabel = k.add([k.text("", FONT_SETTINGS), k.color(255,210,130), k.opacity(0.9), k.fixed(), k.z(90)]);
    ui.comboLabel.hidden = true;
    
    ui.playerHpBarBg = k.add([k.rect(HP_BAR_WIDTH, HP_BAR_HEIGHT, {radius: 5}), k.color(40,40,80), k.opacity(0.6), k.fixed(), k.z(88)]);
    ui.playerHpBarFill = k.add([k.rect(HP_BAR_WIDTH, HP_BAR_HEIGHT, {radius: 5}), k.color(90,220,255), k.fixed(), k.z(89)]);
    ui.enemyHpBarBg = k.add([k.rect(HP_BAR_WIDTH, HP_BAR_HEIGHT, {radius: 5}), k.color(60,30,70), k.opacity(0.6), k.fixed(), k.z(88)]);
    ui.enemyHpBarFill = k.add([k.rect(HP_BAR_WIDTH, HP_BAR_HEIGHT, {radius: 5}), k.color(255,110,140), k.fixed(), k.z(89)]);
    
    ui.cooldownText = k.add([k.text("", {...FONT_SETTINGS, size: 16}), k.color(190,210,255), k.fixed(), k.z(90)]);
    ui.cooldownBg = k.add([k.rect(COOLDOWN_BAR_WIDTH, 12, {radius: 6}), k.color(40,52,110), k.opacity(0.7), k.fixed(), k.z(90)]);
    ui.cooldownFill = k.add([k.rect(COOLDOWN_BAR_WIDTH, 12, {radius: 6}), k.color(110,205,255), k.fixed(), k.z(91)]);
    
    ui.specialText = k.add([k.text("", {...FONT_SETTINGS, size: 16}), k.color(255,200,170), k.fixed(), k.z(90)]);
    ui.specialBg = k.add([k.rect(COOLDOWN_BAR_WIDTH, 12, {radius: 6}), k.color(80,40,110), k.opacity(0.6), k.fixed(), k.z(90)]);
    ui.specialFill = k.add([k.rect(COOLDOWN_BAR_WIDTH, 12, {radius: 6}), k.color(255,156,120), k.fixed(), k.z(91)]);

    // --- Menu & Game Over ---
    ui.menuShade = k.add([k.rect(1,1), k.color(4,6,16), k.opacity(0.82), k.fixed(), k.z(120)]);
    ui.menuShade.hidden = true;
    ui.menuTitle = k.add([k.text("One-Fight", {...FONT_SETTINGS, size: 44}), k.color(200,230,255), k.fixed(), k.z(121)]);
    ui.menuTitle.hidden = true;
    ui.menuSubtitle = k.add([k.text("", {...FONT_SETTINGS, size: 20}), k.color(180,200,255), k.fixed(), k.z(121)]);
    ui.menuSubtitle.hidden = true;
    ui.menuHint = k.add([k.text("", {...FONT_SETTINGS, size: 16}), k.color(140,160,220), k.fixed(), k.z(121)]);
    ui.menuHint.hidden = true;
    ui.highScoreLabel = k.add([k.text("", {...FONT_SETTINGS, size: 20}), k.color(255,210,130), k.fixed(), k.z(121)]);
    ui.highScoreLabel.hidden = true;
    ui.menuButtonBox = k.add([k.rect(220, 44, { radius: 12 }), k.color(70, 90, 180), k.opacity(0.9), k.outline(2, k.rgb(120, 140, 240)), k.area(), k.fixed(), k.z(121)]);
    ui.menuButtonBox.hidden = true;
    ui.menuButtonText = k.add([k.text("demarrer", {...FONT_SETTINGS, size: 20}), k.color(230, 240, 255), k.anchor("center"), k.fixed(), k.z(122)]);
    ui.menuButtonText.hidden = true;

    ui.tutorialShade = k.add([k.rect(1,1), k.color(6,8,22), k.opacity(0.9), k.area(), k.fixed(), k.z(120)]);
    ui.tutorialShade.hidden = true;
    ui.tutorialTitle = k.add([k.text("tutoriel", {...FONT_SETTINGS, size: 36}), k.color(200,230,255), k.anchor("center"), k.fixed(), k.z(121)]);
    ui.tutorialTitle.hidden = true;
    ui.tutorialText = k.add([k.text("", {...FONT_SETTINGS, size: 18}), k.color(180,200,255), k.anchor("center"), k.fixed(), k.z(121)]);
    ui.tutorialText.hidden = true;
    ui.tutorialHint = k.add([k.text("", {...FONT_SETTINGS, size: 16}), k.color(140,160,220), k.anchor("center"), k.fixed(), k.z(121)]);
    ui.tutorialHint.hidden = true;
    ui.gameOverOverlay = k.add([k.rect(1,1, {radius: 24}), k.color(20,16,56), k.opacity(0.92), k.fixed(), k.z(95)]);
    ui.gameOverOverlay.hidden = true;
    ui.gameOverText = k.add([k.text("", FONT_SETTINGS), k.color(255,240,200), k.fixed(), k.z(96)]);
    ui.gameOverText.hidden = true;
    ui.gameOverReplayBox = k.add([k.rect(170, 40, { radius: 10 }), k.color(80, 140, 120), k.opacity(0.9), k.outline(2, k.rgb(120, 200, 160)), k.area(), k.fixed(), k.z(96)]);
    ui.gameOverReplayBox.hidden = true;
    ui.gameOverReplayText = k.add([k.text("rejouer", {...FONT_SETTINGS, size: 18}), k.color(220, 255, 230), k.anchor("center"), k.fixed(), k.z(97)]);
    ui.gameOverReplayText.hidden = true;
    ui.gameOverMenuBox = k.add([k.rect(170, 40, { radius: 10 }), k.color(120, 90, 160), k.opacity(0.9), k.outline(2, k.rgb(170, 130, 210)), k.area(), k.fixed(), k.z(96)]);
    ui.gameOverMenuBox.hidden = true;
    ui.gameOverMenuText = k.add([k.text("menu", {...FONT_SETTINGS, size: 18}), k.color(240, 230, 255), k.anchor("center"), k.fixed(), k.z(97)]);
    ui.gameOverMenuText.hidden = true;

    ui.onStart = null;
    ui.onReplay = null;
    ui.onMenu = null;
    ui.onTutorialContinue = null;

    const resizeDynamic = (obj, scale) => {
        const w = obj.width || 1;
        const h = obj.height || 1;
        const newScale = Math.max(k.width() / w, k.height() / h) * scale;
        obj.scale = k.vec2(newScale);
        obj.pos = k.vec2(k.width() / 2, k.height() / 2);
    }
    
    ui.updateLayout = () => {
        const width = k.width();
        const height = k.height();
        resizeDynamic(ui.background, 1);
        resizeDynamic(ui.vignette, 1);
        
        const panelWidth = Math.max(520, width - HUD_MARGIN * 2);
        const portraitY = HUD_MARGIN + HUD_HEIGHT / 2;
        const centerX = width / 2;
        const leftTextX = HUD_MARGIN + 120;
        const rightTextX = width - HUD_MARGIN - 120;

        ui.hudGlowBack.width = panelWidth + 12;
        ui.hudGlowBack.height = HUD_HEIGHT + 18;
        ui.hudGlowBack.pos = k.vec2(HUD_MARGIN - 6, HUD_MARGIN - 9);

        ui.hudPanel.width = panelWidth;
        ui.hudPanel.height = HUD_HEIGHT;
        ui.hudPanel.pos = k.vec2(HUD_MARGIN, HUD_MARGIN);

        ui.hudTopLine.width = panelWidth;
        ui.hudTopLine.pos = k.vec2(HUD_MARGIN, HUD_MARGIN + 8);
        ui.hudAccent.width = panelWidth;
        ui.hudAccent.pos = k.vec2(HUD_MARGIN, HUD_MARGIN + HUD_HEIGHT - 12);
        ui.hudDivider.height = HUD_HEIGHT - 36;
        ui.hudDivider.pos = k.vec2(centerX, HUD_MARGIN + 18);
        
        ui.playerPortrait.pos = k.vec2(HUD_MARGIN + 60, portraitY);
        ui.enemyPortrait.pos = k.vec2(width - HUD_MARGIN - 60, portraitY);
        
        ui.playerHpLabel.pos = k.vec2(leftTextX, HUD_MARGIN + 18);
        ui.enemyHpLabel.pos = k.vec2(rightTextX, HUD_MARGIN + 18);
        ui.cooldownText.pos = k.vec2(leftTextX, HUD_MARGIN + 46);
        ui.cooldownBg.pos = k.vec2(leftTextX, HUD_MARGIN + 60);
        ui.cooldownFill.pos = k.vec2(leftTextX, HUD_MARGIN + 60);
        ui.specialText.pos = k.vec2(leftTextX, HUD_MARGIN + 82);
        ui.specialBg.pos = k.vec2(leftTextX, HUD_MARGIN + 96);
        ui.specialFill.pos = k.vec2(leftTextX, HUD_MARGIN + 96);
        
        ui.waveLabel.pos = k.vec2(centerX, HUD_MARGIN + 18);
        ui.scoreLabel.pos = k.vec2(centerX, HUD_MARGIN + 44);
        ui.enemyCountLabel.pos = k.vec2(centerX, HUD_MARGIN + 66);
        ui.comboLabel.pos = k.vec2(centerX, HUD_MARGIN + 90);
        
        ui.playerHpBarBg.pos = k.vec2(leftTextX, HUD_MARGIN + 32);
        ui.playerHpBarFill.pos = k.vec2(leftTextX, HUD_MARGIN + 32);
        const enemyBarX = rightTextX - HP_BAR_WIDTH;
        ui.enemyHpBarBg.pos = k.vec2(enemyBarX, HUD_MARGIN + 32);
        ui.enemyHpBarFill.pos = k.vec2(enemyBarX, HUD_MARGIN + 32);
        
        const floorWidth = Math.max(360, width - ARENA_PADDING * 2);
        const floorTop = Math.max(HUD_HEIGHT + 40, height * 0.4);
        const floorHeight = Math.max(220, height - floorTop - ARENA_PADDING);
        ui.arenaFloor.width = floorWidth;
        ui.arenaFloor.height = floorHeight;
        ui.arenaFloor.pos = k.vec2(ARENA_PADDING, floorTop);
        ui.arenaGlow.width = floorWidth;
        ui.arenaGlow.pos = k.vec2(ARENA_PADDING, floorTop - 20);

        ui.menuShade.width = width;
        ui.menuShade.height = height;
        ui.menuTitle.pos = k.vec2(width / 2, height / 2 - 60);
        ui.menuSubtitle.pos = k.vec2(width / 2, height / 2 - 16);
        ui.menuButtonBox.pos = k.vec2(width / 2 - 110, height / 2 + 8);
        ui.menuButtonText.pos = k.vec2(width / 2, height / 2 + 30);
        ui.menuHint.pos = k.vec2(width / 2, height / 2 + 64);
        ui.highScoreLabel.pos = k.vec2(width / 2, height / 2 + 92);

        ui.tutorialShade.width = width;
        ui.tutorialShade.height = height;
        ui.tutorialTitle.pos = k.vec2(width / 2, height / 2 - 80);
        ui.tutorialText.pos = k.vec2(width / 2, height / 2 - 10);
        ui.tutorialHint.pos = k.vec2(width / 2, height / 2 + 74);
        
        ui.gameOverOverlay.pos = k.vec2(width / 2, height / 2);
        ui.gameOverText.pos = k.vec2(width / 2, height / 2);
        ui.gameOverReplayBox.pos = k.vec2(width / 2 - 190, height / 2 + 46);
        ui.gameOverReplayText.pos = k.vec2(width / 2 - 105, height / 2 + 66);
        ui.gameOverMenuBox.pos = k.vec2(width / 2 + 20, height / 2 + 46);
        ui.gameOverMenuText.pos = k.vec2(width / 2 + 105, height / 2 + 66);
    };

    ui.menuButtonBox.onClick(() => {
        if (!ui.menuButtonBox.hidden && ui.onStart) ui.onStart();
    });
    ui.gameOverReplayBox.onClick(() => {
        if (!ui.gameOverReplayBox.hidden && ui.onReplay) ui.onReplay();
    });
    ui.gameOverMenuBox.onClick(() => {
        if (!ui.gameOverMenuBox.hidden && ui.onMenu) ui.onMenu();
    });
    ui.tutorialShade.onClick(() => {
        if (!ui.tutorialShade.hidden && ui.onTutorialContinue) ui.onTutorialContinue();
    });

    ui.updateAllLabels = () => {
        const player = state.player;
        const enemy = state.currentEnemy;
        if (!player) return;
        
        ui.playerHpLabel.text = `joueur pv ${player.hp}`;
        ui.enemyHpLabel.text = (enemy && enemy.exists())
            ? `ennemi ${enemy.typeLabel} pv ${enemy.hp}`
            : "ennemi pv --";
        ui.waveLabel.text = `manche ${state.wave}`;
        ui.scoreLabel.text = `score ${state.score}`;
        ui.enemyCountLabel.text = `ennemis ${state.enemiesRemaining}`;

        const cdProgress = player.canPunch ? 1 : k.clamp(1 - player.cooldownTimer / state.constants.PUNCH_COOLDOWN, 0, 1);
        ui.cooldownFill.width = COOLDOWN_BAR_WIDTH * cdProgress;
        ui.cooldownText.text = cdProgress >= 1 ? "coup pret" : `recharge ${player.cooldownTimer.toFixed(1)}s`;
        
        const spProgress = player.specialReady ? 1 : k.clamp(1 - player.specialCooldownTimer / state.constants.SPECIAL_COOLDOWN, 0, 1);
        ui.specialFill.width = COOLDOWN_BAR_WIDTH * spProgress;
        ui.specialText.text = spProgress >= 1 ? "attaque speciale" : `speciale ${player.specialCooldownTimer.toFixed(1)}s`;
    };
    
    ui.updateHealthBars = () => {
        const player = state.player;
        const enemy = state.currentEnemy;
        if (!player) return;

        const playerRatio = k.clamp(player.hp / state.constants.PLAYER_MAX_HP, 0, 1);
        ui.playerHpBarFill.width = HP_BAR_WIDTH * playerRatio;
        
        const enemyExists = enemy && enemy.exists();
        const enemyHP = enemyExists ? enemy.hp : 0;
        const enemyMax = enemyExists ? enemy.maxHp : state.constants.BASE_ENEMY_HP;
        const enemyRatio = k.clamp(enemyHP / Math.max(1, enemyMax), 0, 1);
        ui.enemyHpBarFill.width = HP_BAR_WIDTH * enemyRatio;
    };
    
    ui.showMenu = () => {
        [ui.menuShade, ui.menuTitle, ui.menuSubtitle, ui.menuHint, ui.highScoreLabel, ui.menuButtonBox, ui.menuButtonText].forEach(e => e.hidden = false);
        ui.menuSubtitle.text = "entree ou clic pour demarrer";
        ui.menuHint.text = "deplacement: fleches | coup: espace | special: f";
        ui.highScoreLabel.text = `meilleur score: ${state.highScore}`;
        k.play("sfx_ui_show", { volume: 0.5 });
    };
    
    ui.hideMenu = () => {
        [ui.menuShade, ui.menuTitle, ui.menuSubtitle, ui.menuHint, ui.highScoreLabel, ui.menuButtonBox, ui.menuButtonText].forEach(e => e.hidden = true);
        k.play("sfx_ui_hide", { volume: 0.5 });
    };

    ui.showTutorial = () => {
        [ui.tutorialShade, ui.tutorialTitle, ui.tutorialText, ui.tutorialHint].forEach(e => e.hidden = false);
        ui.tutorialText.text = "deplacement: fleches\ncoup: espace (maintenir pour charge)\nspecial: f";
        ui.tutorialHint.text = "entree ou clic pour continuer";
        k.play("sfx_ui_show", { volume: 0.5 });
    };

    ui.hideTutorial = () => {
        [ui.tutorialShade, ui.tutorialTitle, ui.tutorialText, ui.tutorialHint].forEach(e => e.hidden = true);
        k.play("sfx_ui_hide", { volume: 0.5 });
    };

    ui.showGameOver = () => {
        ui.gameOverOverlay.hidden = false;
        ui.gameOverText.hidden = false;
        ui.gameOverReplayBox.hidden = false;
        ui.gameOverReplayText.hidden = false;
        ui.gameOverMenuBox.hidden = false;
        ui.gameOverMenuText.hidden = false;
        ui.gameOverOverlay.width = k.width() * 0.5;
        ui.gameOverOverlay.height = 160;
        ui.gameOverText.text = `ko - score: ${state.score}\nentree pour rejouer | m pour menu`;
        k.play("sfx_ui_show", { volume: 0.5 });
    };
    
    ui.hideGameOver = () => {
        ui.gameOverOverlay.hidden = true;
        ui.gameOverText.hidden = true;
        ui.gameOverReplayBox.hidden = true;
        ui.gameOverReplayText.hidden = true;
        ui.gameOverMenuBox.hidden = true;
        ui.gameOverMenuText.hidden = true;
        k.play("sfx_ui_hide", { volume: 0.5 });
    };

    k.onResize(ui.updateLayout);
    ui.updateLayout();

    return ui;
}
